import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import { useSelector } from "react-redux";
import Landing from "../pages/customers/guest/Landing";
import Login from "../pages/customers/guest/Login";
import Register from "../pages/customers/guest/Register";
import VerifyOtp from "../pages/customers/guest/VerifyOtp";
import ForgotPassword from "../pages/customers/guest/ForgotPassword";
import ResetPassword from "../pages/customers/guest/ResetPassword";
import Products from "../pages/customers/guest/Products";
import ContactUs from "../pages/customers/guest/ContactUs";
import TermsConditions from "../pages/customers/guest/T&C";
import PrivacyPolicy from "../pages/customers/guest/PrivacyPolicy";
import ApiDocumentation from "../components/ApiDocumentationPage/ApiDocumentation";

const GuestRoute = () => {
  const { txtconnect_ng_user, isVerified } = useSelector((state) => state.user);

  //* If user is authenticated and verified, redirect to home
  if (txtconnect_ng_user && isVerified) {
    return <Navigate to="/home" replace />;
  }

  //* If user is authenticated but not verified, redirect to verify-otp
  if (txtconnect_ng_user && !isVerified) {
    return <Navigate to="/verify-otp" replace />;
  }

  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/login" element={<Login />} />
      <Route path="/signup" element={<Register />} />
      <Route path="/register" element={<Register />} />
      <Route path="/products" element={<Products />} />
      <Route path="/contact-us" element={<ContactUs />} />
      <Route path="/verify-otp" element={<VerifyOtp />} />
      <Route path="/forgot-password" element={<ForgotPassword />} />
      <Route path="/reset-password" element={<ResetPassword />} />
      <Route path="/terms-and-conditions" element={<TermsConditions />} />
      <Route path="/privacy-policy" element={<PrivacyPolicy />} />
      <Route path="/ApiDocumentation" element={<ApiDocumentation />} />
    </Routes>
  );
};

export default GuestRoute;
